import type {
  Conclusion,
  LifeSketchConclusion,
  NameConclusion,
  Person,
  VitalEventConclusion,
} from '@fs/zion-tree-types'
import { readWrappedData } from './emulators/readWrappedDataBE'
import type { SwrResponse } from './useSwrRequest'
import { useSwrRequest } from './useSwrRequest'

const swrKey = (possibleObsoletePerson: Person | undefined): string | null => {
  return possibleObsoletePerson?.readOnly && possibleObsoletePerson?.deleted && possibleObsoletePerson?.id
    ? `/service/tree/tree-data/person/${possibleObsoletePerson.id}/all`
    : null
}

// Older person type. See https://www.familysearch.org/service/tree/tree-data/json_PersonAll.html
export type AllPerson = {
  isDeletable: boolean
  otherConclusions: Conclusion[]
  birthConclusion?: VitalEventConclusion
  burialConclusion?: VitalEventConclusion
  christeningConclusion?: VitalEventConclusion
  deathConclusion?: VitalEventConclusion
  fullLifeSpan: string
  genderConclusion: VitalEventConclusion
  lifeSketchConclusion?: LifeSketchConclusion
  nameConclusion: NameConclusion
  skeleton: boolean
  discussionCount: number
  dismissedSuggestions?: unknown
  gender: string
  id: string
  isDeleted: boolean
  isLiving: boolean
  lifeSpan: string
  lifeSpanDates: string
  living: boolean
  mePersonCisId?: string
  name: string
  noteCount: number
  obsoleteIdWasRequested: boolean
  portraitUrl?: string
  readOnly: boolean
  sourceCount: number
  suggestions?: unknown
  treeId?: string
  unpublished?: boolean
  visibleToAll: boolean
  visibleToAllWhenUsingFamilySearchApps: boolean
}

export default function useObsoletePerson(
  possibleObsoletePerson: Person | undefined
): SwrResponse<AllPerson> & { possibleObsoletePerson?: AllPerson } {
  const response = useSwrRequest<AllPerson>(swrKey(possibleObsoletePerson), undefined, {
    emulator: readWrappedData,
  })
  return { ...response, possibleObsoletePerson: response.data }
}
